document.addEventListener('DOMContentLoaded', function() {
  // ul要素を取得
  var ulElement = document.querySelector('.c-results-award__list');

  // li要素の数を取得
  var liElements = ulElement.querySelectorAll('li').length;

  // 条件に基づいてクラスを付与または削除
  if (liElements >= 7) {
    ulElement.classList.add('is-row2');
  } else {
    ulElement.classList.remove('is-row2');
  }
});
